import AnalyticsEvent from '../analytics-event';

export class PromoteShopHighlightViewedEvent extends AnalyticsEvent {
  public readonly name = 'Promote Shop Highlight Viewed';
  public properties = {};
}

export class PromoteShopHighlightClosedEvent extends AnalyticsEvent {
  public readonly name = 'Promote Shop Highlight Closed';
  public properties = {};
}
